import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { StyledBreadcrumb } from '../../components/breadcrumb/breadcrumb';
import { ISoldTo } from '../../graphql/types';
import { HOME_PAGE_ROUTE } from '../home/page';
import { soldToRoute } from './route';

export const SoldToPageBreadcrumb: FC<{ soldTo: ISoldTo }> = ({ soldTo }) => {
  return (
    <StyledBreadcrumb>
      <li>
        <Link to={HOME_PAGE_ROUTE}>Home</Link>
      </li>
      <li>
        <Link to={soldToRoute(soldTo.id, {})}>
          Sold To: {soldTo.address.name} {soldTo.id}
        </Link>
      </li>
    </StyledBreadcrumb>
  );
};
